export default __webpack_public_path__ + "static/media/TIENLEN_HISTORY_WEB-VIE.7c6ca71c.jpg";